import { MergeStrategy, SyncStrategy } from 'src/types/pull-request';

export const getBranchDialogHeight = (
  strategies: SyncStrategy[] | MergeStrategy[] | undefined,
  selectedStrategy?: SyncStrategy | MergeStrategy
): number => {
  if (strategies && selectedStrategy) {
    if (
      selectedStrategy === SyncStrategy.Rebase ||
      selectedStrategy === MergeStrategy.FastForward ||
      selectedStrategy === MergeStrategy.RebaseFastForward
    ) {
      // Just strategy dropdown, no commit message input
      return 360;
    } else {
      if (strategies.length === 1) {
        // Commit message input without strategy dropdown
        return 400;
      } else {
        // Commit message input plus strategy dropdown
        return 480;
      }
    }
  }
  // Commit message input without strategy dropdown
  return 400;
};
